// extracted by mini-css-extract-plugin
export var active = "_b4-7";
export var container = "_b4-0";
export var evenWidth = "_b4-4";
export var large = "_b4-5";
export var outlet = "_b4-8";
export var slide = "_b4-2";
export var small = "_b4-6";
export var tab = "_b4-3";
export var tabs = "_b4-1";